import React, { ReactElement } from "react";
import FormSection from "@components/websitebuilderselect/formSection";
import ContactTop from "@components/websitebuilderselect/contactTop";
import { GetServerSideProps } from "next";
import WebsiteBuilderSelectWrapper from "@components/layouts/websiteBuilderSelectWrapper";
import { getPageProps } from "@services/initial-calls";

export default function ContactPage(): ReactElement {
    return (
        <WebsiteBuilderSelectWrapper useSecondaryLogo>
            <div className="bg-white">
                <ContactTop />
            </div>
            <FormSection />
        </WebsiteBuilderSelectWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
